export default __webpack_public_path__ + "static/media/pump truck_transparent.ebaf74be.png";